module.exports = __webpack_public_path__ + "static/work_bright-a73d784dc27485e460049097fc8817fd.mp4";